<div class="list-page">
  <app-asiakas-otsikko otsikko="Asetukset, laskutus" paluuUrl="/asiakkaat" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Apix config (Lemonaid): <a [href]="apixConfigEncodedUriObservable | async" target="_BLANK">{{ apixConfigUriObservable | async }}</a>
      </div>
    </div>
  }

  <form>
    <div style="display: flex; justify-content: space-between; flex-flow: row; align-items: center; margin-bottom: 10px; margin-top: 40px">
      <div class="light-blue-text" style="font-size: 22px">Laskujen toimitus</div>
      <app-primary-button (click)="lisaa()" actionId="Aloita kertalaskun tekeminen" additionalClass="mat-elevation-z4" matIcon="add"> Lisää kertalasku </app-primary-button>
    </div>

    @if (apixForwardConfigObservable | async; as apixForwardConfig) {
      <div>
        @if (apixForwardConfig.forwardActive || apixForwardConfig.paymentReceiveIsActive) {
          <div>
            @if (apixForwardConfig.forwardActive) {
              <div>
                Asiakas on tilannut sähköisten laskujen välityksen pankkiin. Annettu osoite on:
                <ul>
                  <li>Osoite: {{ apixForwardConfig.forwardAddress.sahkoinenOsoite }}</li>
                  <li>Välittäjä: {{ apixForwardConfig.forwardAddress.sahkoinenValittaja }}</li>
                </ul>
                @if (apixForwardConfig.forwardLemontreeLaskut) {
                  <div>
                    Asiakas on tilannut myös Lemon Tree:n laskut välitysosoitteeseen. Lähetystietoja ei voi muokata Lemonatorissa. Jos osoite on väärä, ota yhteys asiakkaaseen.
                    <div>
                      <mat-checkbox [formField]="lomake.estaAlvLaskut">Estä ALV-laskujen lähettäminen</mat-checkbox>
                    </div>
                  </div>
                }
              </div>
            }
            @if (apixForwardConfig.paymentReceiveIsActive) {
              <div>
                Asiakas käyttää sähköisiä Lemonaid-ostolaskuja. Laskut toimitetaan Lemonaidiin osoitteeseen:
                <ul>
                  <li>Osoite: {{ apixForwardConfig.receiveAddress.sahkoinenOsoite }}</li>
                  <li>Välittäjä: {{ apixForwardConfig.receiveAddress.sahkoinenValittaja }}</li>
                </ul>
                <mat-checkbox [formField]="lomake.estaAlvLaskut">Estä ALV-laskujen lähettäminen</mat-checkbox>
              </div>
            }
          </div>
        } @else {
          <div>
            <mat-radio-group [formField]="lomake.spostiVaiEmail">
              <mat-radio-button [value]="'spostilasku'">Sähköpostilasku</mat-radio-button>
              <mat-radio-button [value]="'verkkolasku'">Verkkolasku</mat-radio-button>
            </mat-radio-group>
          </div>
          @if (naytaSahkoinenLaskutus()) {
            <div style="margin-top: 10px">
              @if (asiakkaanOsoitetiedotPuuttuvat()) {
                <div class="lemon-error">Asiakkaan osoitetiedot puuttuvat. (Mene Asetukset -> Asiakastiedot ja tarkista, että katuosoite, postinumero ja postitoimipaikka on täytetty)</div>
              }
              <div style="max-width: 450px">
                <!-- <div class="light-blue-text" style="font-size: 20px; margin-bottom: 10px; line-height: 22px; margin-top: 40px;">Sähköinen laskutusosoite</div> -->
                <mat-form-field style="margin-left: 10px; margin-right: 10px">
                  <mat-label>{{ 'lasku.sposti-dialog.verkkolasku.valittajatunnus' | translate | async }}</mat-label>
                  <input type="text" [matAutocomplete]="operaattoriauto" [formField]="lomake.sahkoinenLaskuValittaja" matInput data-lpignore="true" />
                  <!-- <mat-error>{{fieldErrors.valittaja}}</mat-error> -->
                </mat-form-field>
                <mat-autocomplete #operaattoriauto="matAutocomplete" [displayWith]="valittajaDisplayFn">
                  @for (operaattori of verkkolaskuoperaattorit | async; track operaattori) {
                    <mat-option [value]="operaattori">{{ operaattori.tunnus }} {{ operaattori.nimi }}</mat-option>
                  }
                </mat-autocomplete>
                <mat-form-field style="margin-left: 10px; margin-right: 10px">
                  <mat-label>{{ 'lasku.sposti-dialog.verkkolasku.osoite' | translate | async }}</mat-label>
                  <input type="text" [formField]="lomake.sahkoinenLaskuOsoite" matInput data-lpignore="true" />
                  @if (naytetaankoVirhe(lomake.sahkoinenLaskuOsoite, 'valittaja')) {
                    <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.valittaja' | translate | async }} </mat-error>
                  }
                </mat-form-field>
              </div>
              <mat-checkbox [formField]="lomake.estaAlvLaskut">Estä ALV-laskujen lähettäminen</mat-checkbox>
            </div>
          } @else {
            <div class="light-blue-text" style="font-size: 14px; padding-top: 20px; margin-left: 10px">Laskun vastaanottajat</div>
            <div style="min-height: 150px; display: flex; flex-direction: column; justify-content: space-between">
              <div style="min-height: 60px">
                <mat-chip-grid #vastaanottajaChips>
                  @for (vastaanottaja of asiakas.laskunVastaanottajat; track vastaanottaja) {
                    <mat-chip-option style="margin-top: 1em; margin-left: 20px" [selectable]="false" [removable]="true" (removed)="poistaLaskunVastaanottaja(vastaanottaja)">
                      {{ vastaanottaja }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip-option>
                  }
                </mat-chip-grid>
              </div>
              <!-- {{lisaavastaanottaja?.errors | json}} -->
              <div style="max-width: 400px; margin-left: 20px; margin-top: 10px">
                <mat-form-field>
                  <mat-label>Lisää laskun vastaanottaja</mat-label>
                  <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" (blur)="lisaaLaskunVastaanottaja()" [formField]="lomake.lisaavastaanottaja" (matChipInputTokenEnd)="lisaaLaskunVastaanottaja()" matInput data-lpignore="true" />
                  <!-- <mat-icon matSuffix (click)="lisaa()">add</mat-icon> -->
                  @if (naytetaankoVirhe(lomake.lisaavastaanottaja, 'min')) {
                    <mat-error> Lisää vähintään yksi vastaanottaja. </mat-error>
                  }
                  @if (naytetaankoVirhe(lomake.lisaavastaanottaja, 'email')) {
                    <mat-error> Sähköpostiosoite on virheellinen. </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
        }
      </div>
    } @else {
      <div>
        <mat-radio-group [formField]="lomake.spostiVaiEmail">
          <mat-radio-button [value]="'spostilasku'">Sähköpostilasku</mat-radio-button>
          <mat-radio-button [value]="'verkkolasku'">Verkkolasku</mat-radio-button>
        </mat-radio-group>
      </div>
      @if (naytaSahkoinenLaskutus()) {
        <div style="margin-top: 10px">
          @if (asiakkaanOsoitetiedotPuuttuvat()) {
            <div class="lemon-error">Asiakkaan osoitetiedot puuttuvat. (Mene Asetukset -> Asiakastiedot ja tarkista, että katuosoite, postinumero ja postitoimipaikka on täytetty)</div>
          }
          <div style="max-width: 450px">
            <!-- <div class="light-blue-text" style="font-size: 20px; margin-bottom: 10px; line-height: 22px; margin-top: 40px;">Sähköinen laskutusosoite</div> -->
            <mat-form-field style="margin-left: 10px; margin-right: 10px">
              <mat-label>{{ 'lasku.sposti-dialog.verkkolasku.valittajatunnus' | translate | async }}</mat-label>
              <input type="text" [matAutocomplete]="operaattoriauto" [formField]="lomake.sahkoinenLaskuValittaja" matInput data-lpignore="true" />
              <!-- <mat-error>{{fieldErrors.valittaja}}</mat-error> -->
            </mat-form-field>
            <mat-autocomplete #operaattoriauto="matAutocomplete" [displayWith]="valittajaDisplayFn">
              @for (operaattori of verkkolaskuoperaattorit | async; track operaattori) {
                <mat-option [value]="operaattori">{{ operaattori.tunnus }} {{ operaattori.nimi }}</mat-option>
              }
            </mat-autocomplete>
            <mat-form-field style="margin-left: 10px; margin-right: 10px">
              <mat-label>{{ 'lasku.sposti-dialog.verkkolasku.osoite' | translate | async }}</mat-label>
              <input type="text" [formField]="lomake.sahkoinenLaskuOsoite" matInput data-lpignore="true" />
              @if (naytetaankoVirhe(lomake.sahkoinenLaskuOsoite, 'valittaja')) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.valittaja' | translate | async }} </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-checkbox [formField]="lomake.estaAlvLaskut">Estä ALV-laskujen lähettäminen</mat-checkbox>
        </div>
      } @else {
        <div class="light-blue-text" style="font-size: 14px; padding-top: 20px; margin-left: 10px">Laskun vastaanottajat</div>
        <div style="min-height: 150px; display: flex; flex-direction: column; justify-content: space-between">
          <div style="min-height: 60px">
            <mat-chip-grid #vastaanottajaChips>
              @for (vastaanottaja of asiakas.laskunVastaanottajat; track vastaanottaja) {
                <mat-chip-option style="margin-top: 1em; margin-left: 20px" [selectable]="false" [removable]="true" (removed)="poistaLaskunVastaanottaja(vastaanottaja)">
                  {{ vastaanottaja }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
              }
            </mat-chip-grid>
          </div>
          <!-- {{lisaavastaanottaja?.errors | json}} -->
          <div style="max-width: 400px; margin-left: 20px; margin-top: 10px">
            <mat-form-field>
              <mat-label>Lisää laskun vastaanottaja</mat-label>
              <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" (blur)="lisaaLaskunVastaanottaja()" [formField]="lomake.lisaavastaanottaja" (matChipInputTokenEnd)="lisaaLaskunVastaanottaja()" matInput data-lpignore="true" />
              <!-- <mat-icon matSuffix (click)="lisaa()">add</mat-icon> -->
              @if (naytetaankoVirhe(lomake.lisaavastaanottaja, 'min')) {
                <mat-error> Lisää vähintään yksi vastaanottaja. </mat-error>
              }
              @if (naytetaankoVirhe(lomake.lisaavastaanottaja, 'email')) {
                <mat-error> Sähköpostiosoite on virheellinen. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
    }

    <!-- <div [class.mat-form-field-invalid]="laskunKieli?.errors?.required" class="light-blue-text" style="font-size: 16px; padding-top: 20px; margin-left: 10px;">Laskun kieli</div>
<mat-radio-group formControlName="laskunKieli" style="margin-left: 20px;">
  <mat-radio-button [class.red-text]="laskunKieli?.errors?.required && (laskunKieli?.dirty || laskunKieli?.touched)" value="fi">Suomi</mat-radio-button>
  <mat-radio-button [class.red-text]="laskunKieli?.errors?.required && (laskunKieli?.dirty || laskunKieli?.touched)" value="en">Englanti</mat-radio-button>
</mat-radio-group> -->

    <div class="light-blue-text" style="font-size: 22px; margin-bottom: 0px; line-height: 30px; margin-top: 40px">Viitenumero</div>
    <div style="max-width: 400px; margin-left: 10px">
      <mat-form-field>
        <mat-label>Viitenumero</mat-label>
        <input type="text" [formField]="lomake.viitenumero" matInput data-lpignore="true" />
        <mat-hint>Viitenumero luodaan automaattisesti sen puuttuessa</mat-hint>
        @if (naytetaankoVirhe(lomake.viitenumero, 'required')) {
          <mat-error> Viitenumero puuttuu </mat-error>
        }
        @if (naytetaankoVirhe(lomake.viitenumero, 'viitenumero')) {
          <mat-error> Viitenumero on virheellinen </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="light-blue-text" style="font-size: 22px; margin-bottom: 0px; line-height: 30px; margin-top: 40px">Hinnoittelu</div>

    <h4 style="margin-top: 30px">Kuukausihinta</h4>

    <div style="max-width: 400px; margin-left: 10px; margin-bottom: 30px">
      <mat-form-field>
        <mat-label>Kuukausihinnan perusteet</mat-label>
        <input type="text" [formField]="lomake.hinnanPerusteet" matInput data-lpignore="true" />
      </mat-form-field>
    </div>

    <!-- valid: {{form.valid}}, invalid: {{form.invalid}} -->
    <div style="max-width: 750px">
      @for (hinta of lomake.hinnat; track hinta; let i = $index) {
        <div>
          <div style="display: flex; justify-content: space-between">
            <mat-form-field style="max-width: 120px; margin-left: 10px; margin-right: 10px">
              <mat-label>Kuukausihinta</mat-label>
              <input #hintaInputti decimalNumberField [formField]="hinta.hinta" matInput data-lpignore="true" />
              @if (naytetaankoVirhe(hinta.hinta, 'required')) {
                <mat-error> Hinta puuttuu. </mat-error>
              }
              @if (naytetaankoVirhe(hinta.hinta, 'min')) {
                <mat-error> Hinta on liian alhainen (vähintään 0,00). </mat-error>
              }
              @if (naytetaankoVirhe(hinta.hinta, 'max')) {
                <mat-error> Hinta on liian suuri (enintään 2000,00). </mat-error>
              }
            </mat-form-field>
            <mat-form-field style="max-width: 120px; margin-left: 10px; margin-right: 10px">
              <mat-label>Voimassa alkaen</mat-label>
              <input monthPicker type="text" [min]="annaMinimiPaivamaara(hinta.voimassaAlkaen)" [matDatepicker]="picker" [formField]="hinta.voimassaAlkaen" matInput data-lpignore="true" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              @if (naytetaankoVirhe(hinta.voimassaAlkaen, 'required')) {
                <mat-error> Kuukausi puuttuu </mat-error>
              }
              @if (naytetaankoVirhe(hinta.voimassaAlkaen, 'edellinen')) {
                <mat-error> Muutos ei voi olla samaan aikaan tai ennen edellistä muutosta. </mat-error>
              }
              @if (naytetaankoVirhe(hinta.voimassaAlkaen, 'min')) {
                <mat-error> Uusi muutos voi alkaa aikaisintaan ensi kuussa. </mat-error>
              }
              @if (naytetaankoVirhe(hinta.voimassaAlkaen, 'matDatepickerMin')) {
                <mat-error> Uusi muutos voi alkaa aikaisintaan ensi kuussa. </mat-error>
              }
              <mat-datepicker #picker startView="year" (monthSelected)="chosenMonthHandler($event, hinta, picker)"></mat-datepicker>
            </mat-form-field>
            <mat-form-field style="max-width: 400px; margin-left: 10px; margin-right: 10px">
              <mat-label>Muutoksen syy</mat-label>
              <textarea cdkTextareaAutosize type="text" [formField]="hinta.syy" matInput data-lpignore="true"></textarea>
              @if (!hinta.syy().disabled()) {
                <mat-hint>Kerro miksi hinta muuttuu. Jos asiakassuhde loppuu, kerro myös syy lopettamiseen</mat-hint>
              }
              @if (naytetaankoVirhe(hinta.syy, 'required')) {
                <mat-error> Muutoksen syy puuttuu </mat-error>
              }
            </mat-form-field>
            <app-icon-button [disabled]="!onkoLisattyNollahinta(hinta) && (hinta.hinta().disabled() || 1 > i)" (click)="poistaHintarivi(hinta)" actionId="Poista hintarivi (laskutus)" [dynamicClass]="{ 'mat-elevation-z4': !hinta.hinta().disabled() || onkoLisattyNollahinta(hinta) }" additionalClass="secondarybutton" styles="padding:0;" matIcon="delete_forever"> </app-icon-button>
          </div>
          @if (onkoLisattyNollahinta(hinta)) {
            <div class="nollahinta-tallentamaton">Lisätty 0 € hinta menneelle kuukaudelle. Tallentuu, kun painat Tallenna.</div>
          }
        </div>
      }
    </div>

    @if (naytetaankoVirhe(lomake.hinnat, 'min')) {
      <mat-error style="margin-left: 10px; margin-top: 30px"> Ole hyvä ja syötä vähintään yksi hinta. </mat-error>
    }

    @if (isLastPriceZero() && (lomake.hinnat().dirty() || lomake.hinnat().touched())) {
      <mat-error style="margin-left: 10px; margin-top: 30px">
        Huom! Hinnan nollaaminen on tarpeellista vain poikkeustapauksissa.<br />
        Jos sopimus päättyy, menee tauolle tai pöytälaatikkoon, hintaa ei kuulu nollata.
      </mat-error>
    }

    <div style="padding-top: 10px; margin-left: 10px; margin-top: 50px; padding-bottom: 1.25em">
      <app-secondary-button (click)="lisaaHintarivi()" actionId="Avattu muokkausnäkymä: Lisää hinnanmuutos rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää hinnan muutos </app-secondary-button>
    </div>

    @if (onkoDevaajaTaiKayttotukiObservable | async) {
      <div class="nollahinta-tyokalu">
        <div class="nollahinta-otsikko">0 € hinta menneelle kuukaudelle (IT-tiimi ja käyttötuki)</div>
        <div class="nollahinta-rivi">
          <mat-form-field style="max-width: 150px">
            <mat-label>Voimassa alkaen</mat-label>
            <input monthPicker type="text" [max]="nollahinnanMaksimiKuukausi" [matDatepicker]="nollahintaPicker" [formField]="nollahintaLomake.kuukausi" matInput data-lpignore="true" />
            <mat-datepicker-toggle matSuffix [for]="nollahintaPicker"></mat-datepicker-toggle>
            @if (onkoVirhe(nollahintaLomake.kuukausi, 'required') && nollahintaLomake.kuukausi().touched()) {
              <mat-error> Kuukausi puuttuu </mat-error>
            }
            @if ((onkoVirhe(nollahintaLomake.kuukausi, 'tulevaisuudessa') || onkoVirhe(nollahintaLomake.kuukausi, 'matDatepickerMax')) && nollahintaLomake.kuukausi().touched()) {
              <mat-error> Kuukausi ei voi olla tulevaisuudessa. </mat-error>
            }
            @if (onkoVirhe(nollahintaLomake.kuukausi, 'kuukaudellaOnJoHinta') && nollahintaLomake.kuukausi().touched()) {
              <mat-error> Kuukaudelle on jo hinta. </mat-error>
            }
            <mat-datepicker #nollahintaPicker startView="year" (monthSelected)="valitseNollahinnanKuukausi($event, nollahintaPicker)"></mat-datepicker>
          </mat-form-field>
          <mat-form-field style="max-width: 400px; flex: 1">
            <mat-label>Muutoksen syy</mat-label>
            <textarea cdkTextareaAutosize type="text" [formField]="nollahintaLomake.syy" matInput data-lpignore="true"></textarea>
            @if (onkoVirhe(nollahintaLomake.syy, 'required') && nollahintaLomake.syy().touched()) {
              <mat-error> Muutoksen syy puuttuu </mat-error>
            }
          </mat-form-field>
          <app-secondary-button (click)="lisaaNollahintaMenneelleKuukaudelle()" actionId="Lisää 0 € hinta menneelle kuukaudelle (laskutus)" [actionContext]="[nollahintaLomake().value()]" additionalClass="mat-elevation-z4" matIcon="add"> Lisää 0 € hinta </app-secondary-button>
        </div>
      </div>
    }

    <div style="display: flex; align-items: center; gap: 8px; margin-top: 30px">
      <h4 style="margin: 0">Muut jatkuvat veloitukset</h4>

      <span class="info-icon-wrapper">
        <mat-icon class="info-icon">info_outline</mat-icon>
        <span class="custom-tooltip">
          <strong>Aktiiviset veloitukset pöytälaatikossa:</strong><br />
          Laskutetaan "Pöytälaatikkosopimus, vuosiveloitus".
        </span>
      </span>

      @if (onSuper() && onPoistettujaVeloituksia()) {
        <app-secondary-button (click)="toggleNaytaPoistetut()" actionId="Toggle näytä poistetut veloitukset" [styles]="'font-size: 11px; padding: 4px 8px; margin-left: 8px; display: inline-block; max-width: fit-content;'">
          {{ naytaPoistetut ? 'Piilota poistetut' : 'Näytä poistetut' }}
        </app-secondary-button>
      }
    </div>

    @if (veloitustenTilaIlmoitusObservable | async; as ilmoitus) {
      <div style="background-color: #f6f8f8; padding: 16px 20px; border-radius: 12px; margin-top: 20px; margin-bottom: 15px; display: inline-flex; align-items: center">
        <span style="font-size: 14px">{{ ilmoitus }}</span>
      </div>
    }

    <p style="margin-top: 20px; margin-bottom: 28px; color: #999; font-size: 12px">Jos päättymispäivää ei määritetä, veloitus jatkuu toistaiseksi.</p>

    <div style="max-width: 1300px">
      @for (veloitus of lomake.muutJatkuvatVeloitukset; track veloitus; let i = $index) {
        <div>
          @if (asiakas.muutJatkuvatVeloitukset && asiakas.muutJatkuvatVeloitukset[i]; as veloitusData) {
            @if (!veloitusData.poistettu || naytaPoistetut) {
              <div style="display: flex; flex-wrap: nowrap; gap: 8px; box-sizing: border-box; align-items: flex-start" [class.veloitus-poistettu]="veloitusData.poistettu">
                <mat-form-field style="min-width: 120px; flex: 1 1 140px; max-width: 200px">
                  <mat-label>Tuote</mat-label>
                  <mat-select [formField]="veloitus.tuote">
                    @for (tuote of muutJatkuvatVeloituksetTuotteet(); track tuote) {
                      <mat-option [value]="tuote.avain">
                        {{ tuote.nimi }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (naytetaankoVirhe(veloitus.tuote, 'required')) {
                    <mat-error> Tuote puuttuu. </mat-error>
                  }
                </mat-form-field>
                <mat-form-field style="min-width: 65px; flex: 0 1 80px">
                  <mat-label>Hinta</mat-label>
                  <input decimalNumberField [formField]="veloitus.hinta" matInput data-lpignore="true" />
                  @if (naytetaankoVirhe(veloitus.hinta, 'required')) {
                    <mat-error> Hinta puuttuu. </mat-error>
                  }
                  @if (naytetaankoVirhe(veloitus.hinta, 'notZero')) {
                    <mat-error> Hinta ei voi olla nolla. </mat-error>
                  }
                  @if (naytetaankoVirhe(veloitus.hinta, 'eiVoiOllaNegatiivinen')) {
                    <mat-error> Hinta ei voi olla negatiivinen. </mat-error>
                  }
                  @if (naytetaankoVirhe(veloitus.hinta, 'kampanjahyvitysOltavaNegatiivinen')) {
                    <mat-error> Kampanjahyvityksen hinnan pitää olla negatiivinen. </mat-error>
                  }
                  @if (naytetaankoVirhe(veloitus.hinta, 'max')) {
                    <mat-error> Hinta on liian suuri (enintään 2000,00). </mat-error>
                  }
                </mat-form-field>
                <mat-form-field style="min-width: 90px; flex: 0 1 110px">
                  <mat-label>Laskutusfrekvenssi</mat-label>
                  <mat-select [formField]="veloitus.frekvenssi">
                    <mat-option value="1kk">1 kuukausi</mat-option>
                    <mat-option value="3kk">3 kuukautta</mat-option>
                    <mat-option value="vuosi">Vuosi</mat-option>
                  </mat-select>
                  @if (naytetaankoVirhe(veloitus.frekvenssi, 'required')) {
                    <mat-error> Frekvenssi puuttuu. </mat-error>
                  }
                </mat-form-field>
                <mat-form-field style="min-width: 150px; flex: 0 1 180px">
                  <mat-label>Voimassa alkaen</mat-label>
                  <input monthPicker type="text" [min]="annaMinimiPaivamaara(veloitus.voimassaAlkaen)" [matDatepicker]="veloitusAlkaaPickeri" [formField]="veloitus.voimassaAlkaen" matInput data-lpignore="true" />
                  <mat-datepicker-toggle matSuffix [for]="veloitusAlkaaPickeri"></mat-datepicker-toggle>
                  @if (naytetaankoVirhe(veloitus.voimassaAlkaen, 'required')) {
                    <mat-error> Päivämäärä puuttuu. </mat-error>
                  }
                  @if (onkoVirhe(veloitus.voimassaAlkaen, 'eiKuukaudenAlku')) {
                    <mat-error> Veloitus voi alkaa vain kuukauden ensimmäisenä päivänä. </mat-error>
                  }
                  @if (naytetaankoVirhe(veloitus.voimassaAlkaen, 'min') || naytetaankoVirhe(veloitus.voimassaAlkaen, 'matDatepickerMin')) {
                    <mat-error> Veloitus voi alkaa aikaisintaan seuraavasta laskun lähetyspäivästä. </mat-error>
                  }
                  <mat-datepicker #veloitusAlkaaPickeri startView="year" (monthSelected)="chosenMonthHandlerVeloitus($event, veloitus, veloitusAlkaaPickeri, 'voimassaAlkaen')"></mat-datepicker>
                </mat-form-field>
                <mat-form-field style="min-width: 150px; flex: 0 1 183px">
                  <mat-label>Päättyy (viimeinen lasku)</mat-label>
                  <input monthPicker type="text" [min]="veloitus.voimassaAlkaen().value()" [matDatepickerFilter]="annaPaattyyFilter(veloitus)" [matDatepicker]="veloitusPaattyyPickeri" [formField]="veloitus.paattyy" matInput data-lpignore="true" />
                  <mat-datepicker-toggle matSuffix [for]="veloitusPaattyyPickeri"></mat-datepicker-toggle>
                  @if (naytetaankoVirhe(veloitus.paattyy, 'ennenAlkua')) {
                    <mat-error> Päättymispäivä ei voi olla ennen alkamispäivää. </mat-error>
                  }
                  @if (naytetaankoVirhe(veloitus.paattyy, 'virheellinenPaattymisPaiva')) {
                    <mat-error> Päättymiskuukauden on vastattava laskutusfrekvenssiä. </mat-error>
                  }
                  <mat-datepicker #veloitusPaattyyPickeri startView="year" (monthSelected)="chosenMonthHandlerVeloitus($event, veloitus, veloitusPaattyyPickeri, 'paattyy')"></mat-datepicker>
                </mat-form-field>
                <mat-form-field style="min-width: 100px; flex: 1 1 140px; max-width: 200px">
                  <mat-label>Lisätiedot</mat-label>
                  <input type="text" [formField]="veloitus.lisatiedot" matInput data-lpignore="true" />
                </mat-form-field>
                @if (!veloitusData.poistettu) {
                  <app-icon-button (click)="poistaMuuJatkuvaVeloitusrivi(veloitus)" actionId="Poista muu jatkuva veloitus" additionalClass="mat-elevation-z4 secondarybutton" styles="padding:0;" matIcon="delete_forever"> </app-icon-button>
                }
              </div>
              @if (annaVeloituksenPoistotiedot(i); as poistettu) {
                <div class="veloitus-poistettu-info">
                  <strong>Poistettu:</strong> {{ poistettu.paivitetty?.toDate() | date: 'dd.MM.yyyy HH:mm' }}
                  @if (kirjanpitajatMap().get(poistettu.paivittaja); as poistaja) {
                    | <strong>Poistaja:</strong> {{ poistaja.etunimi }} {{ poistaja.sukunimi }}
                  }
                </div>
              }
            }
          }
        </div>
      }
    </div>

    @if (seuraavaLaskuObservable | async; as esikatselu) {
      <div style="background-color: #eefcff; padding: 15px; margin: 20px 10px; border-radius: 4px; max-width: 600px">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
          <button mat-icon-button (click)="esikatseluEdellinenKuukausi()" style="flex-shrink: 0">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div style="font-weight: 500; text-align: center">Muut jatkuvat veloitukset ({{ esikatselu.kuukausi }})</div>
          <button mat-icon-button (click)="esikatseluSeuraavaKuukausi()" style="flex-shrink: 0">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        @if (esikatselu.rivit.length === 0) {
          <div style="text-align: center; padding: 20px; color: #666">Ei laskutettavaa</div>
        }
        @if (esikatselu.rivit.length > 0) {
          <div>
            @for (rivi of esikatselu.rivit; track rivi) {
              <div style="display: flex; justify-content: space-between; padding: 5px 0">
                <span>{{ rivi.nimi }}</span>
                <span>{{ rivi.hinta | number: '1.2-2' }} €</span>
              </div>
            }
            <div style="border-top: 2px solid #ddd; margin-top: 10px; padding-top: 10px; display: flex; justify-content: space-between; font-weight: 600">
              <span>Yhteensä</span>
              <span>{{ esikatselu.yhteensa | number: '1.2-2' }} €</span>
            </div>
          </div>
        }
        <div style="font-size: 11px; color: #666; margin-top: 10px; text-align: center">Esikatselu päivittyy tallennuksen jälkeen</div>
      </div>
    }

    <div style="padding-top: 10px; margin-left: 10px; margin-top: 50px; padding-bottom: 1.25em">
      <app-secondary-button (click)="lisaaMuujatkuvaVeloitusrivi()" actionId="Avattu muokkausnäkymä: Lisää muut jatkuvat veloitukset rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää veloitus </app-secondary-button>
    </div>

    <div style="max-width: 400px; display: flex; justify-content: space-evenly; padding-top: 40px; padding-bottom: 60px">
      <app-primary-button (click)="save()" actionId="Tallenna laskutusasetukset" [actionContext]="[lomake().value()]" styles="padding: 0 18px;">
        {{ 'yleiset.tallenna' | translate | async }}
      </app-primary-button>
    </div>
  </form>

  <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px">Työkieltohistoria</div>
  <div style="margin-bottom: 20px; margin-top: 20px">
    @if (tyokieltoHistoriaObservable | async; as tyokieltoHistoria) {
      @if (tyokieltoHistoria.length === 0 && !asiakas?.tyokielto) {
        <div style="margin-left: 10px; color: #666">Asiakas ei ole ikinä ollut työkiellossa</div>
      }
      @if (tyokieltoHistoria.length === 0 && asiakas?.tyokielto) {
        <div style="margin-left: 10px; color: #666">Asiakkaalla on työkielto, mutta historiaa ei ole saatavilla.</div>
      }
      @for (entry of tyokieltoHistoria; track entry.avain) {
        <div style="padding: 4px 0; margin-left: 10px">{{ entry.paivitetty?.toDate() | date: 'dd.MM.yyyy HH:mm' }} - {{ annaTyokieltoTapahtumaKuvaus(entry) }} ({{ annaTyokieltoPaivittajanNimi(entry) }})</div>
      }
    }
  </div>

  <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 15px">Asiakkaalle lähetetyt laskut</div>
  <app-laskut></app-laskut>
</div>
